import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addressList: [],
  countryList: [],
  stateList: [],
  cityList: [],
  addressKey: "",
};

const addressSlice = createSlice({
  name: "address",
  initialState: initialState,
  reducers: {
    setAddressList(state, action) {
      state.addressList = action.payload;
    },
    setCountryList(state, action) {
      state.countryList = action.payload;
    },
    setStateList(state, action) {
      state.stateList = action.payload;
    },
    setCityList(state, action) {
      state.cityList = action.payload;
    },
    setAddressKey(state, action) {
      state.addressKey = action.payload;
    },
  },
});

export const {
  setAddressList,
  setCountryList,
  setStateList,
  setCityList,
  setAddressKey,
} = addressSlice.actions;

export default addressSlice.reducer;
